import ReportTable from '../../../../../components/Grid/ReportTable';

export default function ProjetosTable(props: any) {
  return <ReportTable model={props.model} columnCount={10} />;
}
